/**
 * Rewards MFE Route
 * 
 * Loads and renders the Rewards MFE with error boundary protection.
 * 
 * @module components/mfe/RewardsRoute
 */

import React from 'react';
import { MFELoader } from './MFELoader';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { useAuth } from '@/contexts/AuthContext';
import { CommunicationBridge } from '@sequelae/lore-mfe-kit';

export const RewardsRoute: React.FC = () => {
  const { user, logout } = useAuth();
  // Always fetch fresh token from CommunicationBridge instead of using cached token
  const token = CommunicationBridge.getAccessToken();

  if (!token || !user) {
    return <div>Unauthorized</div>;
  }

  return (
    <ErrorBoundary onReset={() => window.location.reload()}>
      <MFELoader
        mfeName="Rewards"
        accessToken={token}
        refUserId={user.id}
        onLogout={logout}
      />
    </ErrorBoundary>
  );
};

